import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var plus_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M11 12.5V17.5H12.5V12.5H17.5V11H12.5V6H11V11H6V12.5H11Z" }) });
export {
  plus_default as default
};
//# sourceMappingURL=plus.js.map
